import { Spinner } from "@/components/ui/spinner";
import { VStack } from "@/components/ui/vstack";
import { useSession } from "@/utils/session.ctx";
import { useRouter } from "expo-router";
import { useEffect } from "react";

export default function LogoutCallback() {
  const session = useSession();
  const router = useRouter();

  useEffect(() => {
    session.signOut().finally(() => {
      router.replace("/auth");
    });
  }, []);

  return (
    <VStack className="gap-6">
      <Spinner size="large" />
    </VStack>
  );
}
